<template>
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-card class="sa-card sa-card-border" header="Scheda psicologica" header-tag="header" footer-tag="footer">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Sintesi clinica</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.sintesiClinica }}</span>
                        <b-form-textarea v-else v-model="jsonDataSchedaPsicologica.sintesiClinica" :readonly="isReadOnly" max-rows="10" rows="4" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Presa in carico psicologica:</label>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-for="presaInCarico in presaInCaricoOptions" :key="'presaInCarico-' + presaInCarico.id" class="sa-switch-select-element">
                        <b-form-checkbox switch :disabled="isReadOnly" v-model="selectedPresaInCarico" :value="presaInCarico.voce" @change="onChangeCheckbox">
                            <span style="font-weight: normal">{{ presaInCarico.voce }}</span>
                        </b-form-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note:</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.note }}</span>
                        <b-form-textarea v-else v-model="jsonDataSchedaPsicologica.note" :readonly="isReadOnly" max-rows="10" rows="5" />
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    mixins: [UtilityMixin],

    props: {
        idRisorsa: {
            type: String,
            default() {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default() {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            pathResourceSchedaPsicologica: "/rsaschedavalutazioneschedapsicologicasuap",
            pathResourceDizionario: "/rsadizionario",

            presaInCaricoOptions: [],

            selectedPresaInCarico: [],

            jsonDataSchedaPsicologica: this.getDefaultSchedaPsicologica(),

            sinoOptions: [
                { value: null, text: "Seleziona valore", disabled: true },
                { value: "SI", text: "SI" },
                { value: "NO", text: "NO" },
            ],
        };
    },

    mounted() {
        let me = this;
        let routeIdAccettazione = me.$route?.query?.idAccettazione ? me.$route.query.idAccettazione : me.$route?.params?.id;

        me.jsonDataSchedaPsicologica = me.getDefaultSchedaPsicologica(this.idAccettazione || routeIdAccettazione);
        me.loadDizionarioData();

        if (me.idRisorsa) {
            me.visualizzaSchedaPsicologica();
        }
    },

    watch: {
        jsonDataSchedaPsicologica: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },

    methods: {
        getDefaultSchedaPsicologica(idAccettazione = null) {
            return {
                id: null,
                idAccettazione: idAccettazione,
                sintesiClinica: null,
                note: null,
                listaSchedaPsicologicaDettagli: [],
            };
        },

        formatDettaglioValue(tipo) {
            if (!this.jsonDataSchedaPsicologica.listaSchedaPsicologicaDettagli) {
                return "";
            }

            return this.jsonDataSchedaPsicologica.listaSchedaPsicologicaDettagli
                .filter((item) => item.tipo === tipo)
                .map((item) => item.voce)
                .join(", ");
        },

        onChangeCheckbox() {
            this.setDettaglioCheckbox();
        },

        setDettaglioCheckbox() {
            let listaSchedaPsicologicaDettagli = [];

            this.selectedPresaInCarico.forEach((voce) => {
                listaSchedaPsicologicaDettagli.push({
                    id: null,
                    idSchedaPsicologica: this.jsonDataSchedaPsicologica.id,
                    tipo: "PRESA IN CARICO PSICOLOGICA",
                    voce: voce,
                });
            });

            this.jsonDataSchedaPsicologica.listaSchedaPsicologicaDettagli = listaSchedaPsicologicaDettagli;
        },

        loadDizionarioData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceDizionario, null, me.loadDizionarioDataSuccess, me.loadDizionarioDataError);
        },

        loadDizionarioDataSuccess(response) {
            let me = this;
            if (response.data.data.list) {
                me.presaInCaricoOptions = response.data.data.list.filter((item) => item.tipo === "PRESA IN CARICO PSICOLOGICA");
            }
        },

        loadDizionarioDataError(error) {
            console.error("Errore nel caricamento dizionario", error);
        },

        visualizzaSchedaPsicologica() {
            let me = this;
            me.selectedPresaInCarico = [];

            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaPsicologica + "/" + me.idRisorsa, null, me.loadDataSchedaPsicologicaSuccess, me.loadDataSchedaPsicologicaError);
        },

        loadDataSchedaPsicologicaSuccess(response) {
            let me = this;
            me.jsonDataSchedaPsicologica = {
                ...me.getDefaultSchedaPsicologica(me.idAccettazione),
                ...response.data.data,
            };
            me.selectedCaregiver = [];
            me.selectedBaseValutazioneIngresso = [];
            me.selectedTipologiaIntervento = [];

            if (me.jsonDataSchedaPsicologica.listaSchedaPsicologicaDettagli) {
                me.jsonDataSchedaPsicologica.listaSchedaPsicologicaDettagli.forEach((dettaglio) => {
                    if (dettaglio.tipo === "PRESA IN CARICO PSICOLOGICA") {
                        me.selectedPresaInCarico.push(dettaglio.voce);
                    }
                });
            }

            me.$emit("afterLoadData", me.jsonDataSchedaPsicologica);
        },

        loadDataSchedaPsicologicaError(error) {
            this.$emit("afterLoadData", error);
            this.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },

        resetForm() {
            this.jsonDataSchedaPsicologica = this.getDefaultSchedaPsicologica(this.idAccettazione);
            this.selectedPresaInCarico = [];
        },
    },
};
</script>
